export default "__VITE_ASSET__C329DA6i__"